var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3576.037,
    y: -573.001,
    display: "inline",
    fill: "#5D5D5D",
    width: 9481.222,
    height: 9392.563
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.579,36.656L38.579,36.656H39c1.122,0,1.122,1.683,0,1.683H11.221c-1.123,0-1.123-1.683,0-1.683h0.42 V19.399c-0.528-0.704-0.841-1.579-0.841-2.525v-3.367c0-0.466,0.376-0.842,0.841-0.842h26.937c0.465,0,0.842,0.376,0.842,0.842 v3.367c0,0.946-0.314,1.821-0.842,2.525L38.579,36.656L38.579,36.656z M36.896,36.656V20.732c-0.522,0.228-1.095,0.351-1.685,0.351 c-1.369,0-2.596-0.658-3.366-1.685c-0.771,1.027-2,1.685-3.367,1.685c-1.369,0-2.597-0.658-3.368-1.685 c-0.772,1.027-2,1.685-3.368,1.685c-1.368,0-2.596-0.658-3.368-1.685c-0.771,1.027-1.999,1.685-3.366,1.685 c-0.591,0-1.162-0.123-1.685-0.351v15.924h14.311V24.449c0-0.465,0.379-0.841,0.844-0.841h6.313c0.466,0,0.842,0.376,0.842,0.841 v12.207H36.896z M12.483,14.348v2.526c0,1.392,1.133,2.525,2.526,2.525c1.393,0,2.524-1.132,2.524-2.525v-2.526H12.483z  M25.953,14.348v2.526c0,1.392,1.132,2.525,2.525,2.525c1.392,0,2.524-1.132,2.524-2.525v-2.526H25.953z M32.688,14.348v2.526 c0,1.392,1.131,2.525,2.524,2.525c1.392,0,2.524-1.132,2.524-2.525v-2.526H32.688z M19.218,16.874c0,1.392,1.132,2.525,2.525,2.525 c1.392,0,2.525-1.132,2.525-2.525v-2.526h-5.051L19.218,16.874L19.218,16.874z M29.318,36.656h4.631V25.292h-4.631V36.656z  M15.43,33.709c-0.465,0-0.841-0.376-0.841-0.841v-8.419c0-0.465,0.376-0.841,0.841-0.841h10.102c0.465,0,0.843,0.376,0.843,0.841 v8.419c0,0.465-0.378,0.841-0.843,0.841H15.43z M24.689,32.027v-6.734h-8.417v6.734H24.689z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.b48fe2beda78706fa257c54a5e433af2.svg";
export { ForwardRef as ReactComponent };